'use client';

import { ContextualPopup as ContextualPopupComponent } from './ContextualPopup';
import { ContextualPopupGyroscopeVisualisation } from './ContextualPopupGyroscopeVisualisation';
import { ContextualPopupHeading } from './ContextualPopupHeading';
import { ContextualPopupHelp } from './ContextualPopupHelp';
import { ContextualPopupSection } from './ContextualPopupSection';
import { ContextualPopupWorldMap } from './ContextualPopupWorldMap';

export const ContextualPopup = Object.assign(ContextualPopupComponent, {
  Heading: ContextualPopupHeading,
  Section: ContextualPopupSection,
  Help: ContextualPopupHelp,
  GyroscopeVisualisation: ContextualPopupGyroscopeVisualisation,
  WorldMap: ContextualPopupWorldMap,
});
